import {DamageWallAction} from 'src/Action';
import {Loc, Location} from 'src/common/map/Location';
import {Game} from '../Game';
import {wallRenderer} from 'src/Pixi/map/WallRenderer';

export class DamageWall {
    public constructor(private game: Game) {
        // Sets instance variables
    }

    public byServer({x, y}: DamageWallAction): void {
        const wall = this.game.map.walls[y][x];
        if (wall) {
            this.game.serverDamaged.add(new Location(x, y).toString());
            wall.damaged = true;
        }
    }

    public byClient({x, y}: Loc): void {
        const wall = this.game.map.walls[y][x];
        if (wall) {
            this.game.clientDamaged.add(new Location(x, y).toString());
            wall.damaged = true;
            wallRenderer.damageWall(x, y);
        }
    }
}



// WEBPACK FOOTER //
// ./src/game/actions/DamageWall.ts